import { createSelector } from 'reselect'

const getLocationRouterSelect = createSelector(
  state => state?.router?.location,
  location => {
    if (!BROWSER) {
      return location
    }

    return {
      ...location,
      origin: window.location.origin
    }
  }
)

export default getLocationRouterSelect
